import $ from "jquery";

const wappHeader = () => {

    const target = ".elementor-nav-menu--dropdown";
    const $target = $(target);

    const init = () => {
        if ($target.length) {
            exec();
        }
    };



    const exec = () => {
        $('.elementor-nav-menu--dropdown > ul > li:last-child').before($('#socialIcon').html());        
    };

    init();
};

try {
    wappHeader();
} catch (error) {
    throw Error(error);
}

